import { render, staticRenderFns } from "./GoodsManagement.vue?vue&type=template&id=715085b9&scoped=true"
import script from "./GoodsManagement.vue?vue&type=script&lang=js"
export * from "./GoodsManagement.vue?vue&type=script&lang=js"
import style0 from "./GoodsManagement.vue?vue&type=style&index=0&id=715085b9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715085b9",
  null
  
)

export default component.exports